import { useContext } from "react";
import { AppContext } from "../App";
import { getWizardSteps } from "../utils/wizardFlow";
import { routes } from "../utils/symbols";

export const useWizardNavigation = () => {
	const { route, data, flow } = useContext(AppContext);
	const steps = getWizardSteps(data, flow);
	const index = steps.indexOf(route);

	if (index === -1 && route === routes.selectCenter) {
		return {
			nextPage: routes.selectDateTime,
			previousPage: routes.selectDateTime,
		};
	}

	return {
		nextPage: steps[index + 1] ?? null,
		previousPage: steps[index - 1] ?? null,
	};
};
